import React, { useState, useEffect } from 'react';
import ChatWidget from '../chatWidget/ChatWidget';
import ChatHeader from '../chatHeader/ChatHeader';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import useResponsive from '../../hooks/useResponsiveClass';

interface ChatScreenProps {
  onClose: () => void;
}

const ChatScreen: React.FC<ChatScreenProps> = ({ onClose }) => {
  const [selectedTab, setSelectedTab] = useState<string>('Home');
  const { isChatOpen } = useSelector((state: RootState) => state.chatScreen);
  const { isMobile, isTablet, isLaptop, isDesktop } = useResponsive();

  const [chatPosition, setChatPosition] = useState<{ top?: string, bottom?: string, left?: string, right?: string }>({
    bottom: '32px',
    right: '20px',
  });

  useEffect(() => {
    const savedPosition = localStorage.getItem('chatPosition');
    if (savedPosition) {
      setChatPosition(JSON.parse(savedPosition));
    }
  }, []);

  useEffect(() => {
    if (chatPosition) {
      localStorage.setItem('chatPosition', JSON.stringify(chatPosition));
    }
  }, [chatPosition]);

  const onBackPress = () => {
    setSelectedTab('home');
  };

  const chatStyle: React.CSSProperties = {
    position: 'fixed',
    zIndex: 2147483647,
    bottom: chatPosition.bottom || '',
    right: chatPosition.right || '',
    top: chatPosition?.top ? '0px' : '',
    left: chatPosition.left || '',
    boxShadow: "0 0 8px #6491C3",
    overflow: 'hidden',
  };

  function getCustomSize(isMobile: boolean) { 
    console.log("getCustomSize isMobile", isMobile +" isTablet "+isTablet+" isLaptop "+isLaptop+" isDesktop "+isDesktop);

    return isMobile ? "customBotSize" : "chat-widget-height" ;
  }

  return (
    <div
      className={`${getCustomSize(isMobile)} flex flex-col rounded-xl bg-white`}
      style={{ ...chatStyle, display: isChatOpen ? 'block' : 'none' }}
    >
      <ChatHeader onClose={onClose} selectedTab={selectedTab} onBackPress={onBackPress} />
      <div className="overflow-y-auto flex-grow h-[93%] max-h-[95%]">
        <ChatWidget />
      </div>
    </div>
  );
};

export default ChatScreen;
